// # Mentor routes configuration
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRouteAdmin from '../protected/protected_route_admin';

// # Import mentee components
import NeoMenteeStep1 from '../../neo_mentorship/neo_m_step1/neo_mentee_step1';
import NeoMenteeStep2 from '../../neo_mentorship/neo_m_step2/neo_mentee_step2';
import NeoTime from '../../neo_mentorship/common/neo_time';
import M1Calendar from '../../neo_mentorship/neo_m_step1/mentoring1/m1_calendar';
import M2Calendar from '../../neo_mentorship/neo_m_step2/mentoring2/m2_calendar';
import Counter1 from '../../neo_mentorship/neo_m_step1/mentoring1/counter1';
import Counter1Page from '../../neo_mentorship/neo_m_step1/mentoring1/counter1_page';
import Counter2 from '../../neo_mentorship/neo_m_step2/mentoring2/counter2';
import Counter2Page from '../../neo_mentorship/neo_m_step2/mentoring2/counter2_page';
import Tasks1 from '../../neo_mentorship/neo_m_step1/tutora1/tasks1';
import MentorNotes1 from '../../neo_mentorship/neo_m_step1/tutora1/mentor_notes1';
import Checklist1 from '../../neo_mentorship/neo_m_step1/management1/checklist1';
import Dedicated1 from '../../neo_mentorship/neo_m_step1/management1/dedicated1';
import MenteeMeetings1 from '../../neo_mentorship/neo_m_step1/management1/mentee_meetings1';
import WeakSpots1 from '../../neo_mentorship/neo_m_step1/management1/weakspots1';
import Assignments1 from '../../neo_mentorship/neo_m_step1/assignments1/assignments1';
import GiveAssignment1 from '../../neo_mentorship/neo_m_step1/assignments1/give_assign1';
import DedicatedTasks1 from '../../neo_mentorship/neo_m_step1/tutora1/give_dedic1';
import MenteeStats1 from '../../neo_mentorship/neo_m_step1/M_stats1/mentee_stats1';
import UWorldQBankStep1 from '../../neo_mentorship/neo_m_step1/qbanks1/uw1';
import AmbossQBankStep1 from '../../neo_mentorship/neo_m_step1/qbanks1/amboss1';
import NBMEQBankStep1 from '../../neo_mentorship/neo_m_step1/qbanks1/nbme1';
import TaskChapter1 from '../../neo_mentorship/neo_m_step1/tutora1/task_chapter1';
import MenteeGuide from '../../neo_mentorship/common/mentee_guide';
import MenteeTasks1 from '../../neo_mentorship/neo_m_step1/mentoring1/mentee_tasks1';

// # Import Step 2 components
import Tasks2 from '../../neo_mentorship/neo_m_step2/tutora2/tasks2';
import MentorNotes2 from '../../neo_mentorship/neo_m_step2/tutora2/mentor_notes2';
import Checklist2 from '../../neo_mentorship/neo_m_step2/management2/checklist2';
import Dedicated2 from '../../neo_mentorship/neo_m_step2/management2/dedicated2';
import MenteeMeetings2 from '../../neo_mentorship/neo_m_step2/management2/mentee_meetings2';
import WeakSpots2 from '../../neo_mentorship/neo_m_step2/management2/weakspots2';
import Assignments2 from '../../neo_mentorship/neo_m_step2/assignments2/assignments2';
import GiveAssignment2 from '../../neo_mentorship/neo_m_step2/assignments2/give_assign2';
import DedicatedTasks2 from '../../neo_mentorship/neo_m_step2/tutora2/give_dedic2';
import MenteeStats2 from '../../neo_mentorship/neo_m_step2/M_stats2/mentee_stats2';
import UWorldQBankStep2 from '../../neo_mentorship/neo_m_step2/qbanks2/uw2';
import AmbossQBankStep2 from '../../neo_mentorship/neo_m_step2/qbanks2/amboss2';
import NBMEQBankStep2 from '../../neo_mentorship/neo_m_step2/qbanks2/nbme2';
import TaskChapter2 from '../../neo_mentorship/neo_m_step2/tutora2/task_chapter2';

const MentorRoutes = () => {
  return (
    <Routes>
      {/* # Step 1 mentee routes */}
      <Route path="step1/:username/*">
        <Route 
          index
          element={
            <ProtectedRouteAdmin>
              <NeoMenteeStep1 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        
        {/* # Calendar and time routes */}
        <Route 
          path="calendar" 
          element={
            <ProtectedRouteAdmin>
              <M1Calendar isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="time" 
          element={
            <ProtectedRouteAdmin>
              <NeoTime stepType="Step 1" isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="stats" 
          element={
            <ProtectedRouteAdmin>
              <MenteeStats1 
                isAdmin={true} 
                isTutor={false} 
                isMentorView={true}
                targetUserId={sessionStorage.getItem('currentViewingMenteeId')} 
              />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="meetings" 
          element={
            <ProtectedRouteAdmin>
              <MenteeMeetings1 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        
        {/* # QBanks routes */}
        <Route 
          path="uworld" 
          element={
            <ProtectedRouteAdmin>
              <UWorldQBankStep1 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="amboss" 
          element={
            <ProtectedRouteAdmin>
              <AmbossQBankStep1 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="nbme" 
          element={
            <ProtectedRouteAdmin>
              <NBMEQBankStep1 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        
        {/* # Mentoring routes */}
        <Route 
          path="mentoring1/counter1" 
          element={
            <ProtectedRouteAdmin>
              <Counter1 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="mentoring1/counter1/:chapterId" 
          element={
            <ProtectedRouteAdmin>
              <Counter1Page isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="mentoring1/tasks" 
          element={
            <ProtectedRouteAdmin>
              <MenteeTasks1 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        
        {/* # Management routes */}
        <Route 
          path="tasks" 
          element={
            <ProtectedRouteAdmin>
              <Tasks1 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="notes" 
          element={
            <ProtectedRouteAdmin>
              <MentorNotes1 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="checklist" 
          element={
            <ProtectedRouteAdmin>
              <Checklist1 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="plan" 
          element={
            <ProtectedRouteAdmin>
              <Dedicated1 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="weakspots" 
          element={
            <ProtectedRouteAdmin>
              <WeakSpots1 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="assignments" 
          element={
            <ProtectedRouteAdmin>
              <Assignments1 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="give-assignment" 
          element={
            <ProtectedRouteAdmin>
              <GiveAssignment1 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="dedicated-tasks" 
          element={
            <ProtectedRouteAdmin>
              <DedicatedTasks1 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="mentee-guide" 
          element={
            <ProtectedRouteAdmin>
              <MenteeGuide isAdmin={true} stepType="1" isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="tutora1/chapter/:chapterId" 
          element={
            <ProtectedRouteAdmin>
              <TaskChapter1 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        {/* # Add route for task chapters with username in URL for mentors */}
        <Route 
          path="tutora1/:username/chapter/:chapterId" 
          element={
            <ProtectedRouteAdmin>
              <TaskChapter1 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
      </Route>
      
      {/* # Step 2 mentee routes */}
      <Route path="step2/:username/*">
        <Route 
          index
          element={
            <ProtectedRouteAdmin>
              <NeoMenteeStep2 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        
        {/* # Calendar and time routes */}
        <Route 
          path="calendar" 
          element={
            <ProtectedRouteAdmin>
              <M2Calendar isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="time" 
          element={
            <ProtectedRouteAdmin>
              <NeoTime stepType="Step 2" isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="stats" 
          element={
            <ProtectedRouteAdmin>
              <MenteeStats2 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="meetings" 
          element={
            <ProtectedRouteAdmin>
              <MenteeMeetings2 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        
        {/* # QBanks routes */}
        <Route 
          path="uworld" 
          element={
            <ProtectedRouteAdmin>
              <UWorldQBankStep2 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="amboss" 
          element={
            <ProtectedRouteAdmin>
              <AmbossQBankStep2 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="nbme" 
          element={
            <ProtectedRouteAdmin>
              <NBMEQBankStep2 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        
        {/* # Mentoring routes */}
        <Route 
          path="mentoring2/counter2" 
          element={
            <ProtectedRouteAdmin>
              <Counter2 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="mentoring2/counter2/:chapterId" 
          element={
            <ProtectedRouteAdmin>
              <Counter2Page isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        
        {/* # Management routes */}
        <Route 
          path="tasks" 
          element={
            <ProtectedRouteAdmin>
              <Tasks2 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="notes" 
          element={
            <ProtectedRouteAdmin>
              <MentorNotes2 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="checklist" 
          element={
            <ProtectedRouteAdmin>
              <Checklist2 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="plan" 
          element={
            <ProtectedRouteAdmin>
              <Dedicated2 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="weakspots" 
          element={
            <ProtectedRouteAdmin>
              <WeakSpots2 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="assignments" 
          element={
            <ProtectedRouteAdmin>
              <Assignments2 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="give-assignment" 
          element={
            <ProtectedRouteAdmin>
              <GiveAssignment2 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="dedicated-tasks" 
          element={
            <ProtectedRouteAdmin>
              <DedicatedTasks2 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="mentee-guide" 
          element={
            <ProtectedRouteAdmin>
              <MenteeGuide isAdmin={true} stepType="2" isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        <Route 
          path="tutora2/chapter/:chapterId" 
          element={
            <ProtectedRouteAdmin>
              <TaskChapter2 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
        {/* # Add route for task chapters with username in URL for mentors */}
        <Route 
          path="tutora2/tasks2/:username/chapter/:chapterId" 
          element={
            <ProtectedRouteAdmin>
              <TaskChapter2 isAdmin={true} isMentorView={true} />
            </ProtectedRouteAdmin>
          } 
        />
      </Route>
      
      {/* # Default redirect */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default MentorRoutes;
